export default function Spelling2() {
  return (
    <table className="table_sticky" style={{ textAlign: "center" }}>
      <tbody>
        <tr>
          <th /> <th> ы </th>
          <th> є </th>
          <th> ј </th>
          <th> ја </th>
          <th> ју </th>
          <th> јо </th>
          <th> је </th>
          <th> ји </th>
          <th> љ њ </th>
        </tr>
        <tr>
          <th>Serbian/Macedonian-based</th> <td> и </td>
          <td> е </td>
          <td> ј </td>
          <td> ја </td>
          <td> ју </td>
          <td> јо </td>
          <td> је </td>
          <td> ји </td>
          <td> љ њ </td>
        </tr>
        <tr>
          <th>Bulgarian-based</th> <td> и </td>
          <td> е </td>
          <td> й </td>
          <td> я </td>
          <td> ю </td>
          <td> йо/ьо </td>
          <td> йе/ье </td>
          <td> и </td>
          <td> ль нь </td>
        </tr>
        <tr>
          <th>East Slavic</th> <td> ы </td>
          <td> е </td>
          <td> й </td>
          <td> я </td>
          <td> ю </td>
          <td> йо/ьо </td>
          <td> (й)е/ье </td>
          <td> и/ьи </td>
          <td> ль нь </td>
        </tr>
      </tbody>
    </table>
  )
}
